import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { GlobalErrorService } from '@app/shared/services/global-error.service';
import { PeopleMetricsRequest, QuarterlyFeedback, VendorPositionsResponse } from '@app/shared/interfaces/quarterly-feedback.model';

@Injectable({
  providedIn: 'root',
})
export class VendorQuarterlyFeedbackService {
  private baseUrl = environment.apiUrl;
   constructor(
     private http: HttpClient,
     private errorHandler: GlobalErrorService,
   ) {}
 
   saveFeedbackFormData(feedbackData: PeopleMetricsRequest,file:File): Observable<any> {
    const formData = new FormData();
    formData.append('vendorPeopleMetricsDto', new Blob([JSON.stringify(feedbackData)], { type: 'application/json' }));
    formData.append('file', file, file.name);

    return this.http.post<any>(
      `${this.baseUrl}/vendor/quarterly-feedback/people-metrics`,
      formData
    ).pipe(
      catchError((error) => this.errorHandler.logError(error))
    );
  }
   
   
   getVendorOpenPositionsAndNicheSkills(vendorId: string, quarter: string, year: number): Observable<VendorPositionsResponse> {
     return this.http
       .get<VendorPositionsResponse>(
         `${this.baseUrl}/vendor/feedback/open-positions/niche-skills/${vendorId}?quarter=${quarter}&year=${year}`
       )
       .pipe(
         catchError((error) => {
           return this.errorHandler.logError(error);
         }),
       );
   }
 }
